const genreIdRegex = /(\d+)@@/;
const subGenreIdRegex = /->(\d+)@@/;
const regexUrlEncode = /(\d+)%40%40/;

export const getGenreIdFromUrl = (str?: string) => {
    const found = str?.match(regexUrlEncode);
    return found ? found[1] : null;
};

export const getGenreId = (id: string) => {
    return regexMapper(id, genreIdRegex);
};
export const getSubGenreId = (id: string) => {
    return regexMapper(id, subGenreIdRegex);
};

export const extractRelevantGenreId = (id: string) => {
    return id.includes('->') ? getSubGenreId(id) : getGenreId(id);
};

function regexMapper(id: string | undefined, regex: RegExp) {
    const match = id?.match(regex);
    return match ? match[1] : null;
}
